export enum KestrelCommands {
  APPEND_ANNOTATIONS = 'appendAnnotations',
  APPEND_SURFACE_AREAS = 'appendSurfaceAreas',
  APPLY_SEGMENTATION = 'applySegmentation',
  APPLY_TEXT_SEGMENTATION = 'applyTextSegmentation',
  AUTHENTICATE_KESTREL_API = 'authenticateKestrelAPI',
  AUTHENTICATE_ROLODEX = 'authenticateRolodex',
  BATCH_SCREENSHOT_ANNOTATIONS = 'batchScreenshotAnnotations',
  CANCEL_BATCH_SCREENSHOT = 'cancelBatchScreenshot',
  CAPTURE_POSE_SCREENSHOT = 'capturePoseScreenshot',
  CHANGE_MEASUREMENT_UNIT = 'changeMeasurementUnit',
  CLEAR_CURRENT_SEGMENT = 'clearCurrentSegment',
  CLEAR_NDE_DATA_LAYER = 'clearNDEDataLayer',
  CREATE_STARTING_VIEW = 'createStartingView',
  CURRENT_CAMERA_POSE = 'currentCameraPose',
  DELETE_ANNOTATION = 'deleteAnnotation',
  DELETE_CAMERA_VIEW = 'deleteCameraView',
  DELETE_INSPECTION_AREA = 'deleteInspectionArea',
  DELETE_MEASUREMENT = 'deleteMeasurement',
  DELETE_NDE_DATA_LAYER = 'deleteNDEDataLayer',
  DELETE_PLANE_INTERSECTION = 'deletePlaneIntersection',
  DELETE_PRIMITIVE = 'deletePrimitive',
  DELETE_SURFACE_AREA = 'deleteSurfaceArea',
  FIT_PRIMITIVE = 'fitPrimitive',
  GENERATE_HOTSPOTS_FROM_POSE = 'generateHotspotsFromPose',
  GENERATE_OUTLINE_FROM_POSE = 'generateOutlineFromPose',
  GET_CURSOR_DATA = 'getCursorData',
  GET_PLANE_INTERSECTION = 'getPlaneIntersection',
  HIDE_ALL = 'hideAll',
  HIDE_ALL_HISTORICAL = 'hideAllHistoricalAnnotations',
  HIDE_GROUP = 'hideGroup',
  HIDE_INSPECTION_GRID = 'hideInspectionGrid',
  HIGHLIGHT_ANNOTATION = 'highlightAnnotation',
  HIGHLIGHT_GROUP = 'highlightGroup',
  HIGHLIGHT_INSPECTION_AREA = 'highlightInspectionArea',
  HIGHLIGHT_MEASUREMENT = 'highlightMeasurement',
  HIGHLIGHT_SURFACE_AREA = 'highlightSurfaceArea',
  LOAD_ANNOTATIONS = 'loadAnnotations',
  LOAD_INSPECTION_AREAS = 'loadInspectionAreas',
  LOAD_MEASUREMENTS = 'loadMeasurements',
  LOAD_NDE_DATA = 'loadNDEData',
  LOAD_PLANE_INTERSECTIONS = 'loadPlaneIntersections',
  LOAD_PRIMITIVES = 'loadPrimitives',
  LOAD_SURFACE_AREA_LABEL_SETTINGS = 'loadSurfaceAreaLabelSettings',
  LOAD_SURFACE_AREAS = 'loadSurfaceAreas',
  NEW_CAMERA_VIEW = 'newCameraView',
  PLAYER_AWAY = 'playerAway',
  REQUEST_TEMPERATURE_PROBE = 'requestTemperatureProbe',
  SET_2D_PLANE_MODE = 'set2DPlaneMode',
  SET_2D_PLANE_MODE_ACTIVE = 'set2DPlaneModeActive',
  SET_2D_PLANE_POSITION = 'set2DPlanePosition',
  SET_2D_PLANE_ROTATION = 'set2DPlaneRotation',
  SET_ANNOTATION_LABEL_BACKGROUND_COLOR = 'setAnnotationLabelBackgroundColor',
  SET_ANNOTATION_LABEL_OUTLINE_COLOR = 'setAnnotationLabelOutlineColor',
  SET_ANNOTATION_LABEL_TEXT_COLOR = 'setAnnotationLabelTextColor',
  SET_CAMERA_POSES = 'setCameraPoses',
  SET_CAMERA_POSES_SCALE = 'setCameraPosesScale',
  SET_CAMERA_POSES_VISIBILITY = 'setCameraPosesVisibility',
  SET_INSPECTION_AREA_DRAWING = 'setInspectionAreaDrawing',
  SET_LABEL_CULLING_ENABLED = 'setLabelCullingEnabled',
  SET_LABEL_VISIBILITY = 'setLabelVisibility',
  SET_MEASUREMENT_LABEL_VISIBILITY = 'setMeasurementLabelVisibility',
  SET_MEASUREMENT_POSITION = 'setMeasurementPrecision',
  SET_MEASUREMENT_SCALE = 'setMeasurementScale',
  SET_MEASUREMENT_TYPE = 'setMeasurementType',
  SET_MODE = 'setMode',
  SET_NAVIGATION_MODE = 'setNavigationMode',
  SET_PLACEMENT_MODE = 'setPlacementMode',
  SET_POINTER_MODE = 'setPointerMode',
  SET_PRIMITIVE_COLOR = 'setPrimitiveColor',
  SET_PRIMITIVE_MOVEMENT_ALLOWED = 'setGlobalPrimitiveMovementAllowed',
  SET_PRIMITIVE_VISIBLE = 'setPrimitiveVisible',
  SET_PRIMITIVES_VISIBLE = 'setPrimitivesVisible',
  SET_THERMAL_GRADIENT_VISIBILITY = 'setThermalGradientVisibility',
  SET_NDE_OPACITY = 'setNDEOpacity',
  SET_VIEW_MODE = 'setViewMode',
  SET_Z_CUTOFF = 'setZCutoff',
  SHOW_ALL = 'showAll',
  SHOW_ALL_HISTORICAL = 'showAllHistoricalAnnotations',
  SHOW_GROUP = 'showGroup',
  SHOW_INSPECTION_GRID = 'showInspectionGrid',
  SHOW_LAYER_RAW = 'showLayerRaw',
  SHOW_LAYER_RGB = 'showLayerRGB',
  SHOW_LAYER_VISUAL = 'showLayerVisual',
  SLICE_ON_ORBIT = 'sliceOnOrbit',
  START_MANUAL_PLACEMENT = 'startManualPlacement',
  TAKE_SCREENSHOT = 'takeScreenshot',
  TOGGLE_INSPECTION_AREA_DRAWING = 'toggleInspectionAreaDrawing',
  TOGGLE_MEASUREMENT_TYPE = 'toggleMeasurementType',
  TOGGLE_NDE_DATA_LAYER = 'toggleNDEDataLayer',
  TOGGLE_PRIMITIVES = 'togglePrimitives',
  UNHIGHLIGHT_ALL_ANNOTATIONS = 'unhighlightAllAnnotations',
  UNHIGHLIGHT_ALL_INSPECTION_AREAS = 'unhighlightAllInspectionAreas',
  UNHIGHLIGHT_ALL_MEASUREMENTS = 'unhighlightAllMeasurements',
  UNHIGHLIGHT_ALL_PRIMITIVES = 'unhighlightAllPrimitives',
  UNHIGHLIGHT_ALL_SURFACE_AREAS = 'unhighlightAllSurfaceAreas',
  UNHIGHLIGHT_GROUP = 'unhighlightGroup',
  UPDATE_ANNOTATION = 'updateAnnotation',
  UPDATE_INSPECTION_AREA = 'updateInspectionArea',
  UPDATE_INSPECTION_GRID = 'updateInspectionGrid',
  UPDATE_MEASUREMENT = 'updateMeasurement',
  UPDATE_PLANE_INTERSECTION = 'updatePlaneIntersection',
  UPDATE_PRIMITIVE = 'updatePrimitive',
  UPDATE_SETTINGS = 'updateSettings',
  UPDATE_SURFACE_AREA = 'updateSurfaceArea',
  SHOW_SEGMENTATION_BBOX = 'showSegmentationBBox',
  HIDE_SEGMENTATION_BBOX = 'hideSegmentationBBox',
  ZOOM_TO_CAMERA_VIEW = 'zoomToCameraView',
  ZOOM_TO_INSPECTION_AREA = 'zoomToInspectionArea',
  ZOOM_TO_LOCATION = 'zoomToLocation',
  ZOOM_TO_STARTING_VIEW = 'zoomToStartingView',
}
